import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";

export default {
  GetSalesRegister(payload) {
    return Api_2().post(`/api/reports/salesRegisterReport`, payload);
  },
  GetSalesRegisterBeta(payload) {
    return Api_2().post(`/api/reports/salesRegisterReport-beta`, payload);
  },
  GetSalesRegisterBeta_Optimized(payload) {
    return Api(payload).post(
      `/api/reports/salesRegisterReport_beta_optimized`,
      payload
    );
  },
  ItemSalesRegister(payload) {
    return Api(payload).post(`/api/reports/itemSalesRegisterReport`, payload);
  },
  PollForSalesRegisterExcel(payload) {
    return Api(payload).post(`/api/reports/check-sales-register-excel`, payload);
  },
  PollForSalesRegisterExcel_Optimized(payload) {
    return Api(payload).post(`/api/reports/check-sales-register-excel`, payload);
  },
  GetGcamNewExcel(payload) {
    return Api(payload).post(`api/reports/gcamReport`, payload);
  },
  GetNewRevenueReport(payload) {
    return Api(payload).post(`api/reports/net-revenue-report`, payload);
  },
  GetReportBuilderFilter(payload) {
    return Api().get(`api/reports/report-builder-v2-filter`, payload);
  },
  GetReportBuilderData(payload) {
    return Api().post(`api/reports/report-builder-v2`, payload);
  },
  GetFoodCategoryAnalytics(payload) {
    return Api(payload).post(`api/reports/fnb-category-analytics`, payload);
  },
  GetVoucherUseageReport(payload) {
    return Api(payload).post(`api/reports/getVoucherUseageReport`, payload);
  },
  GetAdvanceFnBReport(payload) {
    return Api(payload).post(`api/reports/getAdvanceFnbOnline`, payload);
  },
  GetEWalletReport(payload) {
    return Api(payload).post(`api/reports/getEwalletReport`, payload);
  },
  GetSummaryV4(payload) {
    return Api(payload).post(`api/reports/getSummariesV4`, payload);
  },
  GetTransactionSummary(payload) {
    return Api(payload).post(`api/reports/getTransactionSummary`, payload);
  },
  GetPerformanceReportV5(payload) {
    return Api(payload).post(`api/reports/getPerformanceReportV5`, payload);
  },
  GetConcessionPerformanceReportV5(payload) {
    return Api(payload).post(
      `api/reports/getConcessionPerformanceReportV5`,
      payload
    );
  },
  GetOfferRedemptionReport(payload) {
    return Api(payload).post(`api/reports/getOfferRedemptionReport`, payload);
  },
  GetMonthDayWiseReport(payload) {
    return Api_2().post(`api/reports/getMonthDayWiseReport`, payload);
  },
  GetEmpireInvoiceQRLogs(payload) {
    return Api().post(`api/reports/getInvoiceQRLogs`, payload);
  },
  GetFnbRefundReport(payload) {
    return Api(payload).post(`api/reports/getFnbRefundReport`, payload);
  },
  GetDetailedAdvanceSalesReport(payload) {
    return Api(payload).post(
      `/api/reports/getDetailedAdvanceSalesReport`,
      payload
    );
  },
  GetDetailedPriorSalesReport(payload) {
    return Api(payload).post(
      `/api/reports/getDetailedPriorSalesReport`,
      payload
    );
  },
  GetSalesChannelPerformance(payload) {
    return Api(payload).post(`api/reports/getSalesChannelWiseData`, payload);
  },
  GetElectronicPayments(payload) {
    return Api(payload).post(
      `api/reports/getElectronicPaymentsReport`,
      payload
    );
  },
  GetUppLogs(payload) {
    return Api().post(`api/cinema/upp_loyality/getUppLogs`, payload);
  },
  ResendFailedUpp(payload) {
    return Api().post(`api/cinema/upp_loyality/resendUppLogs`, payload);
  },
  GetProductSaleReport(payload) {
    return Api(payload).post(`api/reports/getProductSales`, payload);
  },
  GetDailyCashupReportReport(payload) {
    return Api(payload).post(`/api/reports/getDailyCashupReport`, payload);
  },
  GetDailyOperationsQueryData(payload) {
    return Api(payload).post(`/api/reports/getDailyOperationsReport`, payload);
  },
  GetMovieWiseSummaryReport(payload) {
    return Api().post(`/api/reports/getMovieWiseSummaryReport`, payload);
  },
  GetUserCollectionReport(payload) {
    return Api().post(`/api/reports/getUserCollectionReport`, payload); //in nav.js report is hide
  },
  GetStaffPerfromanceReport(payload) {
    return Api(payload).post(`/api/reports/getStaffPerformance`, payload);
  },
  GetTraffcAnalysis(payload) {
    return Api(payload).post(`/api/reports/get-traffic-analysis`, payload);
  },
  GetFnbSalesAnalysis(payload) {
    return Api(payload).post(
      `/api/reports/getFnBSalesAnalyticsReport`,
      payload
    );
  },
  GetOfferSalesReport(payload) {
    return Api(payload).post(`/api/reports/get-offer-sales-report`, payload);
  },
  GetAuditLog(payload) {
    let qs = createQueryString(payload);
    return Api(payload).get(`/api/reports/user-audit-logs${qs}`);
  },
  GetDcrAndPerformanceReport(payload) {
    return Api(payload).post(`/api/reports/getDCRPerformanceReport`, payload);
  },
  GetSeatClassWiseSalesSummaryReport(payload) {
    return Api(payload).post(
      `/api/reports/getSeatClassWiseSalesSummaryReport`,
      payload
    );
  },
  GetOccupancyAnalysis(payload) {
    return Api(payload).post(
      `/api/reports/getOccupancyAnalysisReport`,
      payload
    );
  },
  GetTransactionRefunds(payload) {
    return Api_2().post(`/api/reports/getTransactionRefundsReport`, payload);
  },
  GetShowDateWiseAdmits(payload) {
    return Api(payload).post(`/api/reports/getShowDateWiseAdmits`, payload);
  },
  GetNumeroData(payload) {
    return Api().post(`/api/reports/getTransactionDetailsForNumero`, payload);
  },
  GetOfflineOnlineTransactionReport(payload) {
    return Api(payload).post(
      `api/reports/getOfflineOnlineTransactionReport`,
      payload
    );
  },
  GetFabOfferReport(payload) {
    return Api(payload).post(`api/reports/getFabOfferReport`, payload);
  },
  getShiftLogsTransactions(payload) {
    return Api(payload).post(`api/reports/getShiftLogsTransactions`, payload);
  },
  GetDailySalesCollectionV2(payload) {
    return Api(payload).post(
      `/api/reports/daily-sales-collection-star-v2`,
      payload
    );
  },
  GetDrawerLogs(payload) {
    return Api_2().post(`/api/reports/getDrawerLogs`, payload);
  },
  getCustomerFnbTransactions(payload) {
    return Api_2().post(`/api/reports/getCustomerFnbTransactions`, payload);
  },
  GetMovieWiseCollectionReport(payload) {
    return Api_2().post(`/api/admin/v2/getMovieWiseCollectionReport`, payload);
  },
  GetWeekWiseMovieCollectionReport(payload) {
    return Api(payload).post(
      `/api/admin/v2/getWeekWiseMovieWiseReport`,
      payload
    );
  },
  GetTransactionsMovieName() {
    return Api().post(`/api/admin/v2/getTransactionMovieName`);
  },
  getTicketInvoicesReport(payload) {
    return Api(payload).post(
      `/api/reports/getTicketInvoicesReportMif`,
      payload
    );
  },
  getCinemaTaxVatAnalysisReport(payload) {
    return Api(payload).post(
      `/api/reports/getCinemaTaxVatAnalysisReport`,
      payload
    );
  },
  getCinemaTaxOverallAnalysisReport(payload) {
    return Api(payload).post(
      `/api/reports/getCinemaTaxOverallAnalysisReport`,
      payload
    );
  },
  getCinemaTaxScreenAnalysisReport(payload) {
    return Api(payload).post(
      `/api/reports/getCinemaTaxScreenAnalysisReport`,
      payload
    );
  },
  getTicketReprintReport(payload) {
    return Api(payload).post(`/api/reports/getTicketReprintReport`, payload);
  },
  GetTransactionRefundsOld(payload) {
    return Api(payload).post(
      `/api/reports/getTransactionRefundsReportOld`,
      payload
    );
  },
  getCashierSettlementReport(payload) {
    return Api(payload).post(
      `/api/reports/getCashierSettlementReport`,
      payload
    );
  },
  getCashierAnalysisReport(payload) {
    return Api(payload).post(`/api/reports/getCashierAnalysisReport`, payload);
  },
  getFnbCourtseyReport(payload) {
    return Api(payload).post(`/api/report/courtsey_fnb_report`, payload);
  },
  getFnbCourtseyRefundReport(payload) {
    return Api(payload).post(`/api/report/courtsey_fnb_refund_report`, payload);
  },
  getHardwareList(payload) {
    return Api(payload).post(`/api/master/hardware_lists`, payload);
  },
  getTicketReport(payload) {
    return Api(payload).post(`/api/reports/getTicketReport`, payload);
  },
  getFnbSalesRevenuePerItem(payload) {
    return Api(payload).post(`/api/reports/getFnbSalesRevenuePerItem`, payload);
  },
  getRemaningItemPerConcession(payload) {
    return Api(payload).post(
      `/api/reports/getRemaningItemPerConcession`,
      payload
    );
  },
  getCallCenterBookings(payload) {
    return Api(payload).post(`/api/reports/getCallCenterBookings`, payload);
  },
   getCurrentStockReportNew(payload) {
    return Api(payload).post(`/api/reports/getCurrentStockReportNew`, payload);
  },
   getDistributorShareReportReportNew(payload) {
    return Api(payload).post(
      `/api/reports/getDistributorShareReportReportNew`,
      payload
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/NewReportService.js